import { Link } from "@prikverwerker/models/link";

export class ActionHelper {

  static getActionLink(actionLinks: Link[], action: string): Link | undefined {
    return actionLinks?.find(actionLink => actionLink.rel === action);
  }

}
